import axios from "axios";
import { API_URL } from "./index";








class StatisticsService {
    runReviewUsers = (params) => {
        return axios
            .get(API_URL.review("statistics"), {
                params,
            })
            .then((response) => response.data);
    };
    runTagsQuery = (params) => {
        return axios.get(API_URL.review("tags-uses"), {
            params,
        });
    };

    runCategoryReportQuery = (params) => {
        return axios.get(API_URL.filmRelease("category-statistics"), {
            params
        });
    };
}

export default new StatisticsService();
